"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedcleanhands = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 58 48",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedcleanhands` : '') + (description ? ` desc-brandedcleanhands` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedcleanhands"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedcleanhands"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M37.5 18.53c0 4.76-3.8 7.95-8.47 7.95-4.68 0-8.46-3.19-8.46-7.95C20.57 13.78 29.03 0 29.03 0s8.47 13.79 8.47 18.53Z",
    fill: "#DAFCFE"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M48.32 44.18v-5.71l7.46-8.57a7.77 7.77 0 0 0 1.46-6.87L52.1 5.58a2.67 2.67 0 0 0-1.57-1.73 2.6 2.6 0 0 0-2.31.2 2.74 2.74 0 0 0-1.17 3.07l3.15 16.1-7.45 8.58 2.21-7.8a2.7 2.7 0 0 0-2.04-3.22A2.62 2.62 0 0 0 40 22.3l-3.86 8.57a9.74 9.74 0 0 0-.86 3.99v9.34h13.03Z",
    fill: "#F4BD96"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M42.72 21.77a1.82 1.82 0 0 1 1.4 2.19l-.32 1.14-3.48-1.36.43-.95a1.79 1.79 0 0 1 1.97-1.02Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M49.37 48c.54 0 .97-.45.97-.99V43.9a.98.98 0 0 0-.97-.99H34.38a.98.98 0 0 0-.97.99V47c0 .54.44.99.97.99h14.99Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.68 44.18v-5.71l-7.46-8.58a7.77 7.77 0 0 1-1.46-6.86L5.9 5.57c.23-.79.81-1.44 1.57-1.73.76-.3 1.61-.23 2.3.2a2.74 2.74 0 0 1 1.18 3.08L7.8 23.22l7.45 8.57-2.21-7.8a2.7 2.7 0 0 1 2.04-3.21c1.2-.24 2.4.38 2.9 1.5l3.86 8.57c.57 1.26.86 2.61.86 4v9.33H9.68Z",
    fill: "#F4BD96"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.42 21.93a1.82 1.82 0 0 0-1.4 2.2l.32 1.14 3.48-1.37-.43-.94a1.79 1.79 0 0 0-1.98-1.03Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.9 48a1 1 0 0 0 .98-1v-3.1a.98.98 0 0 0-.98-1H8.92a.98.98 0 0 0-.97 1V47a1 1 0 0 0 .97 1H23.9Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M29 26.5c4.64 0 8.41-3.2 8.41-7.95 0-1.92-1.37-5.3-3-8.68-3.58 4.85-8 8.97-13.07 12.14 1.33 2.78 4.25 4.49 7.65 4.49Z",
    fill: "#8AE6EB"
  }));
};
var _default = exports.default = brandedcleanhands;